import Reflux from 'reflux';
import AlertActions from 'flux/actions/AlertActions';
import BaseMixin from 'flux/stores/BaseMixin';
import KeyBindingActions from 'flux/actions/KeyBindingActions';
import UIRegions from 'shared/constants/UIRegions';
import AlertTypes from 'shared/constants/AlertTypes';
import { Map } from 'immutable';

/**
 * AlertStore
 *
 * Keeps track of alert visibility
 *
 */
export default Reflux.createStore({
  listenables: [AlertActions],

  mixins: [BaseMixin],

  init() {
    this.setStateAndTrigger(
      Map({
        type: AlertTypes.genericAlert,
        message: null,
      }),
    );
  },

  onShow(message, key, type) {
    if (key === UIRegions.Cuesheet) {
      this._rebindNavigationKeysOnHideCallback = () => {
        KeyBindingActions.bindHotKeys();
        KeyBindingActions.bindNavigationKeys();
      };

      /**
       * Unbind keys so that user can quickly hit enter to close modal
       */
      KeyBindingActions.unbindHotKeys();
      KeyBindingActions.unbindNavigationKeys();
    }

    const next = this.getState()
      .set('message', message)
      .set('type', type || AlertTypes.genericAlert);

    this.setStateAndTrigger(next);
  },

  onHide() {
    if (this._rebindNavigationKeysOnHideCallback) {
      this._rebindNavigationKeysOnHideCallback();
      delete this._rebindNavigationKeysOnHideCallback;
    }

    const end = this.getState().set('message', null);

    this.setStateAndTrigger(end);
  },
});
